/**
 * Preset C — "glass-floating": premium look with a translucent floating
 * sidebar over a soft background gradient and a slim top bar.
 */
import { useState } from "react";
import { Outlet } from "react-router-dom";
import { Brand } from "./Brand";
import { Topbar } from "./Topbar";
import { SidebarLink } from "./SidebarLink";
import { adminNav } from "./nav";
import { useFilteredAdminNav } from "@/hooks/useEnabledNav";

export function AdminLayoutC() {
  const filteredNav = useFilteredAdminNav();
  const [navOpen, setNavOpen] = useState(false);
  return (
    <div className="relative min-h-screen flex bg-bg">
      {navOpen && (
        <div className="fixed inset-0 z-40 bg-black/50 lg:hidden" onClick={() => setNavOpen(false)} aria-hidden />
      )}
      {/* Decorative background blobs */}
      <div
        className="pointer-events-none absolute inset-0 -z-10"
        aria-hidden
      >
        <div className="absolute -top-24 -left-24 h-96 w-96 rounded-full blur-3xl opacity-30 bg-grad-primary" />
        <div className="absolute bottom-[-12rem] right-[-8rem] h-[28rem] w-[28rem] rounded-full blur-3xl opacity-20 bg-grad-accent" />
      </div>

      <aside
        className={`fixed inset-y-0 left-0 z-50 h-screen w-64 shrink-0 glass flex flex-col transition-transform duration-200 lg:sticky lg:top-4 lg:self-start lg:h-[calc(100vh-2rem)] lg:ml-4 lg:rounded-2xl lg:overflow-hidden lg:translate-x-0 lg:z-auto ${navOpen ? "translate-x-0" : "-translate-x-full"}`}
      >
        <div className="h-16 px-5 flex items-center border-b border-white/5">
          <Brand />
        </div>
        <nav className="flex-1 overflow-y-auto p-3 space-y-0.5" onClick={() => setNavOpen(false)}>
          {filteredNav.map((item) => (
            <SidebarLink key={item.label} item={item} />
          ))}
        </nav>
        <div className="p-3 border-t border-white/5">
          <div className="rounded-xl bg-grad-primary p-3 text-primary-foreground">
            <p className="text-xs font-medium opacity-90">Glass · v1</p>
            <p className="text-[11px] opacity-75 mt-0.5">Layout preset C</p>
          </div>
        </div>
      </aside>

      <div className="flex-1 flex flex-col min-w-0">
        <div className="px-4 pt-4 sticky top-0 z-20">
          <div className="rounded-2xl glass overflow-hidden">
            <Topbar onMenuToggle={() => setNavOpen(true)} />
          </div>
        </div>
        <main className="flex-1 p-6 lg:p-8 max-w-[1600px] w-full mx-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
